import React, { useEffect } from "react";
import {
  Box,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import FlexBetween from "components/FlexBetween";
import { fetchUser } from "reduxStore/actions/userActions";
import { useDispatch, useSelector } from "react-redux";
import ALT_Values_Grouped from "assets/images/ALT_Values_Grouped.png";
import ALT_Values_Grouped_Dark from "assets/images/ALT_Values_Grouped_Dark.png";
import { ChevronRight } from "@mui/icons-material";

function Navbar({ isSideBarOpen, setIsSideBarOpen }) {
  const { palette } = useTheme();
  const alt = palette.background.alt;
  const dispatch = useDispatch();
  const mode = useSelector((state) => state.mode);
  const isDarkMode = mode === "dark";

  const user = useSelector((state) => state.user);
  const userId = user?._id;

  const isLargeScreen = useMediaQuery("(min-width:1000px)");

  useEffect(() => {
    dispatch(fetchUser(userId));
  }, [dispatch, userId]);

  return (
    <FlexBetween
      py={isLargeScreen ? "1rem" : "0.5rem"}
      px={isLargeScreen ? "2rem" : "1rem"}
      backgroundColor={alt}
      marginBottom="1rem"
    >
      <Box
        display="flex"
        alignItems="center"
        // justifyContent="center"
        gap="1rem"
        // flexGrow={1}
      >
        {!isLargeScreen && (
          <IconButton onClick={() => setIsSideBarOpen(!isSideBarOpen)}>
            <ChevronRight />
          </IconButton>
        )}
        <Typography
          variant="h1"
          fontWeight={700}
          fontSize={isLargeScreen ? "2rem" : "1rem"}
        >
          ALT Coach
        </Typography>
      </Box>

      <img
        src={isDarkMode ? ALT_Values_Grouped_Dark : ALT_Values_Grouped}
        alt="CPT Tracker"
        style={{
          // cursor: "pointer",
          height: isLargeScreen ? "64px" : "32px",
          width: "auto",
        }}
      />
    </FlexBetween>
  );
}

export default Navbar;
